<template>
  <el-dialog
		class="home_measures_dialog"
    :title="$lodash.get(model, 'bedName', '-' ) !== null ? $lodash.get(model, 'bedName', '-' ) : '-'"
    :visible.sync="visible"
    width="900px"
    :before-close="closeDialog"
		:modal-append-to-body="false"
		:append-to-body="true"
		@close="closeDialog"
  >
    <div class="chart-container">
      <HealthyMeasureChartsCardItem 
				v-if="model"
				:type="model.item"
				:echartId="'HealthyMeasureChartsCardItem-' + model.item"
				:option="getChartOption()"
				:model="model"
			/>
    </div>
  </el-dialog>
</template>

<script>
import HealthyMeasureChartsCardItem from '../../../component/healthy/component/HealthyMeasureChartsCardItem.vue';
import getEchartOptionMeasure1 from '../../../component/chartOptions/echartOptionMeasure1';

export default {
  name: 'HomeMeasuresDialog',
	props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
		parentModel: {
			type: Object,
			default: null
		}
  },
	components: {
		HealthyMeasureChartsCardItem
	},
	watch: {
    dialogVisible(newVal) {
      this.visible = newVal;
    },
		visible(newVal) {
			if (newVal == true && this.$props.parentModel) {
				this.getMeasureData();
			} else {
				this.model = null;
			}
		}
	},
  data() {
    return {
      visible: this.dialogVisible,
			model: null
    };
  },
  mounted() {
		
  },
  beforeDestroy() {
    // 销毁 ECharts 实例，防止内存泄漏
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      // 可选：通知父组件弹窗关闭的逻辑
    },
		closeDialog() {
			this.$emit('update:dialogVisible', false); // 触发事件，父组件监听
		},
		// 获取当日测量情况
    getMeasureData(){
			let params = {
				bedId: this.$props.parentModel.bedId,
				item: this.$props.parentModel.itemType
			}
      this.$get(
        'api/measure/measureItemDetails',
        params,
        (res) => {
          if (res.code === 0) {
            if (res.data) {
							this.model = res.data;
						} else {
						}
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
		getChartOption() {

			// 1.获取图表类型
			let type = this.$lodash.get(this.model, 'item', [] ) !== null ? this.$lodash.get(this.model, 'item', [] ) : [];

			// 2.正常范围
			let normal_range = [];
			let normal_range_2 = null;
			if (type === 'oxygenSaturation') normal_range = [95, 100];
			if (type === 'pulseRate') normal_range = [40, 100];
			if (type === 'bloodPressure') {
				normal_range = [90, 139];
				normal_range_2 = [60, 89];
			};
			if (type === 'bodyTemperature') normal_range = [0, 37.5];

			// 3.正常区域
			let mark_area = { // 收缩压和其他
				silent: true,
				itemStyle: {
          color: 'rgba(24, 144, 255, 0.1)',
					opacity: 0.06
        },
			};
			let mark_area_2 = { // 舒张压
				silent: true,
				itemStyle: {
          color: 'rgba(195, 148, 254, 0.1)',
					opacity: 0.07
        },
			};
			if (type === 'bloodPressure') {
				mark_area.data = [[{yAxis: normal_range[0]}, {yAxis: normal_range[1]}]];
				mark_area_2.data = [[{yAxis: normal_range_2[0]}, {yAxis: normal_range_2[1]}]];
			} else {
				mark_area.data = [[{yAxis: normal_range[0]}, {yAxis: normal_range[1]}]];
			}

			// X轴数据
			let xAxis_data = this.$lodash.get(this.model, 'xaxis', [] ) !== null ? this.$lodash.get(this.model, 'xaxis', [] ) : [];
			
			// Series Data
			let series = [];

			let tempDatas = this.$lodash.get(this.model, 'data', [] ) !== null ? this.$lodash.get(this.model, 'data', [] ) : []
			let serveDatas = JSON.parse(JSON.stringify(tempDatas));
			for (let i = 0; i < serveDatas.length; i ++) {

				let item = serveDatas[i];

				let series_item = {
					type: 'line',
					lineStyle: {
						width: 1,
						color: 'rgba(24, 144, 255, 1)'
					},
					symbol: 'circle',
					symbolSize: 6,
					itemStyle: {
						color: 'rgba(24, 144, 255, 1)'
					}
				};

				let series_item_2 = {
					type: 'line',
					lineStyle: {
						width: 1,
						color: 'rgba(24, 144, 255, 1)'
					},
					symbol: 'circle',
					symbolSize: 6,
					itemStyle: {
						color: 'rgba(24, 144, 255, 1)'
					}
				};

				if (type === 'bloodPressure') {
					series_item.lineStyle.type = 'dashed'
				}

				let series_item_data = []

				let series_item_data_2 = [];

				if (item) {
					for (let j = 0; j < item.length; j++) {
						let subItem = item && item[j] ? JSON.parse(JSON.stringify(item[j])) : {};
						let subItem_2 = item && item[j] ? JSON.parse(JSON.stringify(item[j])) : {};

						subItem.fType = type;
						subItem_2.fType = type;

						if (type === 'bloodPressure') { // 血压
							// 判断是否为正常值
							let dict = {value: subItem.itemValueAvg, extra: subItem, itemStyle: {color: 'rgba(24, 144, 255, 1)'}};
							if (subItem.itemAbnormalAvg == 1) {
								dict.itemStyle.color = 'rgba(255, 113, 134, 1)';
							}
							dict.extra.sType = 'systolicBloodPressure';

							// 判断是否为正常值
							let dict_2 = {value: subItem_2.itemValue2Avg, extra: subItem_2, itemStyle: {color: 'rgba(24, 144, 255, 1)'}};
							if (subItem_2.itemAbnormal2Avg == 1) {
								dict_2.itemStyle.color = 'rgba(255, 113, 134, 1)';
							}
							dict_2.extra.sType = 'diastolicBloodPressure';

							series_item_data.push(dict);
							series_item_data_2.push(dict_2);
						} else {
							// 判断是否为正常值
							let dict = {value: subItem.itemValueAvg, extra: subItem, itemStyle: {color: 'rgba(24, 144, 255, 1)'}};
							if (subItem.itemAbnormalAvg == 1) {
								dict.itemStyle.color = 'rgba(255, 113, 134, 1)';
							}
							series_item_data.push(dict);
						}
					}
				} else {
					series_item_data.push(null);
					series_item_data_2.push(null);
				}
				series_item.data = series_item_data;

				series_item.markArea = mark_area;

				series.push(series_item);

				if (type === 'bloodPressure') {
					series_item_2.data = series_item_data_2;

					series_item_2.markArea = mark_area_2;

					series.push(series_item_2);
				}
			}

			let minValue = type === 'oxygenSaturation' ? 70 : type === 'pulseRate' ? 40 : type === 'bloodPressure' ? 50 : 30
			
			return getEchartOptionMeasure1(
				{
					xAxis_data: xAxis_data,
					series: series,
					extends_data: tempDatas
				}, minValue
			);
		}
  }
};
</script>

<style lang="scss">
.home_measures_dialog {
  // 弹窗头部样式
  .el-dialog__header {
    background-color: rgba(243, 244, 247, 1);
    padding: 16px 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);

    .el-dialog__title {
      font-size: 16px;
      font-weight: 500;
    }

    .el-dialog__headerbtn {
      top: 16px;
      right: 20px;

      .el-dialog__close {
        color: #909399;
        &:hover {
          color: #409EFF;
        }
      }
    }
  }

  // 弹窗内容区样式
  .el-dialog__body {
    padding: 20px;
    background-color: rgba(243, 244, 247, 1);
  }

  // 图表容器整体样式
  .chart-container {
    width: 100%;
  }
}
</style>